/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Thu Nov 23 2023 15:26:59
 */
// @flow

import React from 'react';
import { withI18n } from '@shopify/react-i18n';

type Props = {
  image: React.ReactNode,
  heading: string,
  description: string,
  pagination: React.ReactNode
};

const Step = (props: Props) => {
  const { image, heading, description, pagination } = props;
  return (
    <div className="GuideTour__Step" data-tour="observable-parent">
      {image && <div className="Step__Gif">{image}</div>}
      <div className="Step__Content">
        <h2 className="Heading">{heading}</h2>
        <div className="Description">{description}</div>
      </div>
      {pagination && <div className="Step__Navigation">{pagination}</div>}
    </div>
  );
};

export default withI18n()(Step);
